import { onlineManager, type QueryClient } from "@tanstack/react-query";

import { isApiClientError } from "../api/errors";
import { shellBootstrapKey } from "../shell/bootstrap";

/**
 * Перечитывает данные после возврата связи.
 *
 * Пока связи не было, на сервере могли поменяться пользователь, его права и
 * организация, появиться уведомления и правки коллег. `invalidateQueries` без
 * фильтра заново запрашивает всё, что открыто на экране: оболочку (текущий
 * пользователь, права, навигация), уведомления и данные страницы. Остальное
 * помечается устаревшим и перечитается при следующем открытии.
 *
 * Если сессия истекла, пока человек был без связи, оболочка ответит 401 —
 * тогда его нужно вернуть ко входу, а не оставлять на экране со старыми правами.
 */
export async function resyncAfterReconnect(
  queryClient: QueryClient,
  onSessionExpired: () => void,
): Promise<void> {
  // Свои обработчики события online срабатывают раньше, чем TanStack Query
  // узнаёт о сети, а запрос, начатый «в офлайне», он не выполняет, а ставит на
  // паузу и тут же считает перечитанным. Сообщаем ему о сети сами, до запросов.
  onlineManager.setOnline(true);
  await queryClient.invalidateQueries();
  const error = queryClient.getQueryState(shellBootstrapKey)?.error;
  if (isApiClientError(error) && error.status === 401) onSessionExpired();
}
